import { Site } from '@envato/foundation-types'

import React from 'react'
import classnames from 'classnames'

import { reportToggleFiltersPanel } from '../../../../common/analytics/filtersAnalytics'
import ShowFilters from '../../icons/showFilters'

import styles from './index.module.css'

const ToggleButton = ({
  expanded,
  toggleSidebar,
  activeFiltersCount,
  currentSite
}) => {
  const buttonClass = classnames(styles.buttonToggle, {
    [styles.active]: expanded && currentSite !== Site.photodune,
    [styles.deactive]: !expanded && currentSite !== Site.photodune,
    [styles.alwaysActive]: expanded && currentSite === Site.photodune,
    [styles.alwaysDeactive]: !expanded && currentSite === Site.photodune
  })

  const extendedLabelClass = classnames(styles.label, styles.hideOnMobile)

  const filtersCounter = classnames(styles.label, styles.hideOnDesktop)

  const onClickHandler = () => {
    document.body.classList.toggle('mobileScrollLock')
    reportToggleFiltersPanel(expanded)
    toggleSidebar()
  }

  return (
    <div className={styles.toggleContainer}>
      <button
        className={buttonClass}
        onClick={onClickHandler}
        data-test-selector="toggle-filters-panel"
      >
        <ShowFilters
          width="18"
          height="18"
          className={styles.showFiltersIcon}
        />
        <span className={styles.label}>Filter</span>
        {activeFiltersCount !== 0 && (
          <span className={filtersCounter}>({activeFiltersCount})</span>
        )}
        <span className={extendedLabelClass}>& Refine</span>
      </button>
    </div>
  )
}

export default ToggleButton
